export default {
    error: {
        abort_403_message: 'Truy cập bị từ chối. Bạn có thể không có quyền truy cập trang này.',
        abort_403_text: 'Không có quyền',
        abort_404_message: 'Trang bạn đang tìm kiếm có thể đã bị xóa, đổi tên hoặc tạm thời không khả dụng.',
        abort_404_text: 'Không tìm thấy trang',
        something_went_wrong: 'Đã xảy ra lỗi!',
        required: {
            address_in_cambodia: 'Địa chỉ là bắt buộc',
            email: 'Email là bắt buộc',
            first_name: 'Tên là bắt buộc',
            gender: 'Giới tính là bắt buộc',
            identity_date: 'Ngày cấp CMND là bắt buộc',
            identity_image_back: 'Ảnh mặt sau CMND là bắt buộc',
            identity_image_front: 'Ảnh mặt trước CMND là bắt buộc',
            identity_issued_date: 'Ngày cấp CMND là bắt buộc',
            identity_number: 'Số CMND là bắt buộc',
            last_name: 'Họ là bắt buộc',
            nationality: 'Quốc tịch là bắt buộc',
            passport_image_front: 'Ảnh mặt trước hộ chiếu là bắt buộc',
            passport_image_back: 'Ảnh mặt sau hộ chiếu là bắt buộc',
            passport_number: 'Số hộ chiếu là bắt buộc',
            password: 'Mật khẩu là bắt buộc',
        },
        saving: 'Lỗi lưu dữ liệu'
    },
    label: {
        about: "Về chúng tôi",
        action: "Hành động",
        add: "Thêm",
        address: "Địa chỉ",
        address_in_cambodia: "Địa chỉ tại Campuchia",
        admin_dashboard: "Bảng điều khiển quản trị",
        agree_to: "Tôi đồng ý với",
        all: "Tất cả",
        already_have_account: "Đã có tài khoản? Đăng nhập.",
        amendment: "Sửa đổi",
        amendment_date: "Yêu cầu gia hạn ngày",
        amendment_office: "Yêu cầu thay đổi cửa khẩu",
        amount: "Số tiền",
        app_dashboard: "Bảng điều khiển ứng dụng",
        app_name: "e-Customs",
        application: "Đơn đăng ký",
        application_report: "Báo cáo đơn đăng ký",
        applications: "Đơn đăng ký",
        approve: "Phê duyệt",
        approve_changed_border_gate: "Phê duyệt thay đổi cửa khẩu",
        approve_extended_date_of_entry: "Phê duyệt gia hạn ngày nhập cảnh",
        approve_extended_date_of_exit: "Phê duyệt gia hạn ngày xuất cảnh",
        asterisk: "Bắt buộc",
        attachment: "Tệp đính kèm",
        back: "Quay lại",
        back_side: "Mặt sau",
        between: "Giữa",
        border_pass_date: "Ngày cấp giấy thông hành biên giới",
        border_pass_number: "Số giấy thông hành biên giới",
        brand: "Nhãn hiệu",
        browse_your_device: "Duyệt thiết bị của bạn",
        by_user: "bởi người dùng",
        change_border_gate_of_entry: "Thay đổi cửa khẩu nhập cảnh",
        change_border_gate_of_exit: "Thay đổi cửa khẩu xuất cảnh",
        change_image: "Thay đổi hình ảnh",
        changed_at: "Đã thay đổi lúc",
        choose: "Chọn",
        choose_document: "Chọn tệp",
        choose_driver: "Chọn lái xe",
        choose_image: "Chọn hình ảnh",
        choose_vehicle: "Chọn phương tiện",
        city: "Thành phố",
        close: "Đóng",
        code: "Mã",
        collapse: "Thu gọn",
        color: "Màu sắc",
        company_address: "Địa chỉ công ty",
        company_code: "Mã công ty",
        company_information: "Thông tin công ty",
        company_name: "Tên công ty",
        confirm: "Xác nhận",
        confirm_delete: "Bạn có chắc chắn muốn xóa?",
        confirm_password: "Xác nhận mật khẩu",
        contain: "Chứa",
        create: "Tạo",
        create_application: "Tạo đơn đăng ký",
        created_at: "Được tạo lúc",
        criteria: "Tiêu chí",
        currency: "Tiền tệ",
        customs_registration: "Đăng ký hải quan",
        dashboard: "Bảng điều khiển",
        date: "Ngày",
        declaration: "Tờ khai",
        declaration_chart: "Biểu đồ tờ khai",
        declaration_status: "Đơn đăng ký của tôi",
        declaration_status_today: "Đơn đăng ký hôm nay của tôi",
        declarations: "Tờ khai",
        decline: "Từ chối",
        decline_changed_border_gate: "Từ chối thay đổi cửa khẩu",
        decline_extended_date_of_entry: "Từ chối gia hạn ngày nhập cảnh",
        decline_extended_date_of_exit: "Từ chối gia hạn ngày xuất cảnh",
        delete: "Xóa",
        delete_success: "Xóa thành công",
        deleted_at: "Đã xóa lúc",
        description: "Mô tả",
        destination: "Điểm đến",
        destination_assess: "Đánh giá điểm đến",
        destination_change: "Đã thay đổi điểm đến",
        destination_office_code: "Mã văn phòng điểm đến",
        destination_office_date: "Ngày điểm đến",
        destination_office_name: "Văn phòng điểm đến",
        destination_assess_status: "Trạng thái đánh giá điểm đến",
        document_size: "Kích thước tài liệu phải nhỏ hơn hoặc bằng 5MB.",
        dont_have: "Không có",
        download: "Tải xuống",
        driver: "Lái xe",
        driver_information: "Thông tin lái xe",
        drivers: "Lái xe",
        driving_license: "Bằng lái xe",
        driving_license_image_back: "Ảnh mặt sau bằng lái xe",
        driving_license_image_front: "Ảnh mặt trước bằng lái xe",
        driving_license_photo: "Ảnh bằng lái xe",
        edit: "Chỉnh sửa",
        email: "Email",
        empty_data: "Không có dữ liệu hiển thị",
        engine_number: "Số máy",
        enrouting: "Đang di chuyển",
        entry: "Nhập cảnh",
        entry_date: "Ngày nhập cảnh",
        entry_office_code: "Mã văn phòng nhập cảnh",
        entry_office_name: "Tên văn phòng nhập cảnh",
        entry_vehicles: "Phương tiện nhập cảnh",
        entry_vehicles_today: "Phương tiện nhập cảnh hôm nay",
        equal: "Bằng",
        exit: "Xuất cảnh",
        exit_date: "Ngày xuất cảnh",
        exit_office_code: "Mã văn phòng xuất cảnh",
        exit_office_name: "Tên văn phòng xuất cảnh",
        exit_vehicles: "Phương tiện xuất cảnh",
        exit_vehicles_today: "Phương tiện xuất cảnh hôm nay",
        expand: "Mở rộng",
        expired_date: "Ngày hết hạn",
        extended_date_of_entry: "Gia hạn ngày nhập cảnh",
        extended_date_of_exit: "Gia hạn ngày xuất cảnh",
        female: "Nữ",
        file_name: "Tên tệp",
        filter: "Lọc",
        first_name: "Tên",
        forgot_password: "Quên mật khẩu?",
        frame_number: "Số khung",
        fraud: "Gian lận",
        from: "Từ",
        from_date: "Từ ngày",
        front_side: "Mặt trước",
        fullname: "Họ và tên",
        gender: "Giới tính",
        greater_than: "Lớn hơn",
        greater_than_or_equal: "Lớn hơn hoặc bằng",
        guarantee_information: "Thông tin bảo lãnh",
        guarantee_information_invalid: "Thông tin bảo lãnh không hợp lệ",
        have: "Có",
        having_passport: "Có hộ chiếu?",
        home: "Trang chủ",
        i_am_also_a_driver: "Bạn có phải là lái xe?",
        i_am_also_driver: "Tôi cũng là lái xe",
        id: "ID",
        identity_card: "Chứng minh nhân dân",
        identity_card_expired_date: "Ngày hết hạn CMND",
        identity_card_photo: "Ảnh chứng minh nhân dân",
        identity_date: "Ngày cấp CMND",
        identity_image_back: "Ảnh mặt sau CMND",
        identity_image_front: "Ảnh mặt trước CMND",
        identity_number: "Số CMND",
        image_back: "Ảnh mặt sau",
        image_front: "Ảnh mặt trước",
        image_size: "Kích thước hình ảnh phải nhỏ hơn hoặc bằng 2MB.",
        input_information_invalid: "Thông tin đầu vào không hợp lệ",
        insurance_company_code: "Mã công ty bảo hiểm",
        insurance_company_name: "Tên công ty bảo hiểm",
        insurance_date: "Ngày bảo hiểm",
        insurance_number: "Số bảo hiểm",
        is_required: "Là bắt buộc",
        issued_date: "Ngày cấp",
        last_name: "Họ",
        leave_page_subtitle: "bạn có thay đổi chưa được lưu!",
        leave_page_title: "Bạn có thực sự muốn rời đi?",
        length_of_stay: "Thời gian lưu trú",
        less_than: "Nhỏ hơn",
        less_than_or_equal: "Nhỏ hơn hoặc bằng",
        list: "Danh sách",
        loading: "Đang tải dữ liệu ...",
        lodgement: "Nơi nộp hồ sơ",
        lodgement_assess: "Đánh giá nơi nộp hồ sơ",
        lodgement_assess_approve: "Phê duyệt văn phòng nộp hồ sơ",
        lodgement_assess_reject: "Từ chối văn phòng nộp hồ sơ",
        lodgement_office_code: "Mã văn phòng nộp hồ sơ",
        lodgement_office_date: "Ngày nộp hồ sơ",
        lodgement_office_name: "Văn phòng nộp hồ sơ",
        lodgement_assess_status: "Trạng thái đánh giá nơi nộp hồ sơ",
        login: "Đăng nhập",
        login_description: "Đăng nhập để bắt đầu phiên làm việc",
        login_information: "Thông tin đăng nhập",
        male: "Nam",
        months: ["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],
        more_info: "Thêm thông tin",
        my_profile: "Hồ sơ của tôi",
        n0: "Số",
        name: "Tên",
        nationality: "Quốc tịch",
        next: "Tiếp theo",
        no: "Không",
        no_application: "Bạn chưa có đơn đăng ký nào",
        no_data: "Không có dữ liệu phù hợp với tìm kiếm của bạn",
        no_image: "Không có hình ảnh",
        no_overstay: "Không có tờ khai quá hạn lưu trú",
        no_recently_declaration: "Không có tờ khai gần đây",
        not_equal: "Không bằng",
        number: "Số",
        office: "Văn phòng",
        office_code: "Mã văn phòng",
        officer: "Cán bộ",
        ok: "Đồng ý",
        other: "Tài liệu khác",
        other_attachment_title: "Tệp đính kèm phải là loại hình ảnh và kích thước nhỏ hơn 5 MB.",
        other_document: "Tài liệu khác",
        other_file_criteria: "Loại tệp cho phép: jpeg, png, jpg, pdf & Kích thước: 10MB",
        other_information: "Thông tin khác",
        over_stay_applications: "Tờ khai quá hạn lưu trú",
        overstay: "Quá hạn lưu trú",
        owner: "Chủ sở hữu",
        owner_also_driver: "Chủ sở hữu cũng là lái xe",
        owner_border_pass: "Giấy thông hành biên giới của chủ sở hữu",
        owner_confirm: "Bạn có phải là chủ sở hữu?",
        owner_information: "Thông tin chủ sở hữu",
        owner_passport: "Hộ chiếu của chủ sở hữu",
        passport: "Hộ chiếu",
        passport_date: "Ngày cấp hộ chiếu",
        passport_expired_date: "Ngày hết hạn hộ chiếu",
        passport_image_back: "Ảnh mặt sau hộ chiếu",
        passport_issued_date: "Ngày cấp hộ chiếu",
        passport_number: "Số hộ chiếu",
        passport_photo: "Ảnh hộ chiếu",
        password: "Mật khẩu",
        password_confirmation: "Xác nhận mật khẩu",
        penalize: "Phạt",
        phone: "Điện thoại",
        plate_number: "Biển số xe",
        print: "In",
        profile: "Hồ sơ",
        qrcode: "Mã QR",
        reason: "Lý do",
        receipt_number: "Số biên lai",
        recent_declaration: "Tờ khai gần đây",
        register: "Đăng ký",
        register_date: "Ngày đăng ký",
        register_new_account: "Đăng ký tài khoản mới",
        register_number: "Số đăng ký",
        register_type: "Loại đăng ký",
        register_year: "Năm đăng ký",
        reject: "Từ chối",
        reload: "Tải lại",
        remove: "Xóa bỏ",
        report: "Báo cáo",
        request_change: "Yêu cầu thay đổi",
        request_change_entry_date: "Yêu cầu thay đổi ngày nhập cảnh",
        request_change_entry_office: "Yêu cầu thay đổi văn phòng nhập cảnh",
        request_change_exit_date: "Yêu cầu thay đổi ngày xuất cảnh",
        request_change_exit_office: "Yêu cầu thay đổi văn phòng xuất cảnh",
        request_changed_border_gate: "Yêu cầu thay đổi cửa khẩu",
        request_extended_date_of_entry: "Yêu cầu gia hạn ngày nhập cảnh",
        request_extended_date_of_exit: "Yêu cầu gia hạn ngày xuất cảnh",
        reset_password: "Đặt lại mật khẩu",
        resolve: "Giải quyết",
        restore: "Khôi phục",
        result: "Kết quả",
        return_home: "Trở về trang chủ",
        save: "Lưu",
        save_continue: "Lưu & Tiếp tục",
        scan: "Quét",
        search: "Tìm kiếm",
        search_application: "Tìm kiếm đơn đăng ký",
        search_driver: "Tìm kiếm lái xe",
        search_not_found: "Không tìm thấy đơn đăng ký",
        search_vehicle: "Tìm kiếm phương tiện",
        security_returned: "Bảo lãnh này đã được hoàn trả",
        select: "Chọn",
        select_driver: "Vui lòng chọn lái xe",
        select_vehicle: "Vui lòng chọn phương tiện",
        send: "Gửi",
        serial: "Số seri",
        setting: "Cài đặt",
        setup_my_profile: "Thiết lập hồ sơ của tôi",
        sign_in: "Đăng nhập",
        size: "Kích thước",
        status: "Trạng thái",
        steer: "Vô lăng",
        submit: "Gửi",
        temporary_export: "Xuất tạm thời",
        temporary_import: "Nhập tạm thời",
        temporary_vehicle: "Phương tiện tạm thời",
        terms_conditions: "Điều khoản & Điều kiện",
        timeline: "Dòng thời gian",
        to: "Đến",
        to_date: "Đến",
        today_entry: "Nhập cảnh hôm nay",
        today_exit: "Xuất cảnh hôm nay",
        total_declaration: "Tổng số tờ khai",
        total_vehicle: "Tổng số phương tiện",
        type: "Loại",
        update: "Cập nhật",
        update_profile: "Cập nhật hồ sơ",
        updated_at: "Cập nhật lúc",
        valid_from: "Có hiệu lực từ",
        valid_to: "Có hiệu lực đến",
        value_1: "Giá trị số 1",
        value_2: "Giá trị số 2",
        vehicle: "Phương tiện",
        vehicle_and_driver: "Phương tiện và lái xe",
        vehicle_chart: "Biểu đồ phương tiện",
        vehicle_identitation_back: "Ảnh mặt sau giấy tờ phương tiện",
        vehicle_identitation_front: "Ảnh mặt trước giấy tờ phương tiện",
        vehicle_identity_photo: "Ảnh giấy tờ phương tiện",
        vehicle_information: "Thông tin phương tiện",
        vehicle_report: "Báo cáo phương tiện",
        vehicle_type: "Loại phương tiện",
        vehicles: "Phương tiện",
        view: "Xem",
        view_attachment: "Xem tệp đính kèm",
        view_detail: "Xem chi tiết",
        view_document: "Xem tài liệu",
        view_image: "Xem hình ảnh",
        year: "Năm",
        yes: "Có",
        your_email: "Email của bạn",
        your_information: "Thông tin của bạn",
        your_password: "Mật khẩu của bạn",
        zip: "Mã bưu điện",
        pending: "Đang chờ",
        edit_detail: "Chỉnh sửa chi tiết",
        owners: "Chủ sở hữu",
        search_owner: "Tìm kiếm chủ sở hữu",
        choose_owner: "Chọn chủ sở hữu",
        select_owner: "Vui lòng chọn chủ sở hữu",
        declined: "Đã từ chối",
        destination_approved: 'Văn phòng điểm đến đã phê duyệt',
    },
    message: {
        already_declaration: "Đã khai báo rồi!",
        approve_amendment: "Bạn có muốn phê duyệt yêu cầu này?",
        click_to_view: "Nhấp để xem tệp đính kèm",
        decline_amendment: "Bạn có muốn từ chối yêu cầu này?",
        instruction_info: "Vui lòng nhấp vào nút Đồng ý, hệ thống sẽ đưa bạn đến hoàn thành thông tin.",
        no_driver: "Bạn chưa có thông tin lái xe!",
        no_result: "Không có kết quả!",
        no_vehicle: "Bạn chưa có thông tin phương tiện!",
        not_update_passport: "Bạn chưa hoàn thành thông tin hộ chiếu!",
        not_update_profile: "Bạn chưa cập nhật hồ sơ!",
        profile_completion_message: "Hồ sơ của bạn chưa hoàn tất để đăng ký. Vui lòng thiết lập hồ sơ của bạn!",
        profile_completion_title: "Chú ý!",
        profile_success: "Lưu hồ sơ thành công!",
        required_if_no_identity_card: "Thông tin này sẽ là bắt buộc nếu không có chứng minh nhân dân",
        required_if_no_passport: "Thông tin này sẽ là bắt buộc nếu không có hộ chiếu",
        success: "Lưu tài liệu thành công!",
        verify_phone: "Chúng tôi sẽ xác minh tài khoản của bạn bằng số điện thoại này, vui lòng đảm bảo rằng nó chính xác.",
        please_complete_declaration_owner_first: 'Vui lòng hoàn thành thông tin chủ sở hữu trước!',
        owner_success: "Lưu chủ sở hữu thành công!",
        driver_success: "Lưu lái xe thành công!",
        vehicle_success: "Lưu phương tiện thành công!",
    },
    validation: {
        attributes: {
            address: "Địa chỉ",
            address_in_cambodia: "Địa chỉ tại Campuchia",
            attachment: "tệp đính kèm",
            border_pass_date: "Ngày cấp giấy thông hành biên giới",
            border_pass_number: "Số giấy thông hành biên giới",
            owner_border_pass_number: "Số giấy thông hành biên giới",
            brand: "Nhãn hiệu",
            color: "Màu sắc",
            company_code_v1: "Mã công ty",
            destination_entry_date: "Ngày nhập cảnh",
            destination_entry_office_name: "Tên văn phòng nhập cảnh",
            destination_exit_date: "Ngày xuất cảnh",
            destination_exit_office_name: "Tên văn phòng xuất cảnh",
            destination_office_code_v1: "Mã văn phòng điểm đến",
            destination_office_date_v1: "Ngày văn phòng điểm đến",
            destination_office_date_v2: "Ngày văn phòng điểm đến",
            driver_address_in_cambodia: "Địa chỉ tại Campuchia",
            driver_border_pass_date: "Ngày cấp giấy thông hành biên giới",
            driver_border_pass_number: "Số giấy thông hành biên giới",
            driver_first_name: "Tên",
            driver_gender: "Giới tính",
            driver_last_name: "Họ",
            driver_nationality: "Quốc tịch",
            driver_passport_expired_date: "Ngày hết hạn hộ chiếu",
            driver_passport_issued_date: "Ngày cấp hộ chiếu",
            driver_passport_number: "số hộ chiếu",
            driving_license_image_back: "Ảnh mặt sau bằng lái xe",
            driving_license_image_front: "Ảnh mặt trước bằng lái xe",
            engine_number: "Số máy",
            entry_date: "Ngày nhập cảnh",
            entry_office_name: "Tên văn phòng nhập cảnh",
            exit_date: "Ngày xuất cảnh",
            exit_office_name: "Tên văn phòng xuất cảnh",
            first_name: "Tên",
            frame_number: "Số khung",
            fraud_code: "Mã gian lận",
            fraud_name: "Tên gian lận",
            fraud_valid_from: "Gian lận có hiệu lực từ",
            fraud_valid_to: "Gian lận có hiệu lực đến",
            from_date: "Từ ngày",
            full_name: "họ và tên",
            fullname: "họ và tên",
            fullname_v1: "Họ và tên",
            gender: "Giới tính",
            gender_v1: "Giới tính",
            identity_date: "Ngày cấp CMND",
            identity_date_expire: "Ngày hết hạn CMND",
            identity_image_back: "Ảnh mặt sau CMND",
            identity_image_front: "Ảnh mặt trước CMND",
            identity_number: "Số CMND",
            identity_v1: "CMND",
            insurance_company_code: "Mã công ty bảo hiểm",
            insurance_company_name: "Tên công ty bảo hiểm",
            insurance_date: "Ngày bảo hiểm",
            insurance_number: "Số bảo hiểm",
            last_name: "Họ",
            lodgement_office_code_v1: "Mã văn phòng nộp hồ sơ",
            lodgement_office_date_v1: "Ngày văn phòng nộp hồ sơ",
            lodgement_office_date_v2: "Ngày văn phòng nộp hồ sơ",
            nationality: "Quốc tịch",
            nationality_v1: "Quốc tịch",
            office_code: "Mã văn phòng",
            other: "Tài liệu khác",
            owner_border_pass_date: "Ngày cấp giấy thông hành biên giới",
            owner_border_pass_v1: "Giấy thông hành biên giới của chủ sở hữu",
            owner_passport_number: "số hộ chiếu của chủ sở hữu",
            owner_passport_v1: "Hộ chiếu của chủ sở hữu",
            passport_expired_date: "Ngày hết hạn hộ chiếu",
            passport_image_back: "Ảnh mặt sau hộ chiếu",
            passport_image_front: "Ảnh mặt trước hộ chiếu",
            passport_issued_date: "Ngày cấp hộ chiếu",
            passport_number: "Số hộ chiếu",
            passport_v1: "Hộ chiếu",
            plate_number: "Biển số xe",
            profile_address: "Địa chỉ",
            profile_driving_license_image_back: "Ảnh mặt sau bằng lái xe",
            profile_driving_license_image_front: "Ảnh mặt trước bằng lái xe",
            profile_first_name: "Tên",
            profile_gender: "Giới tính",
            profile_identity_date: "Ngày cấp CMND",
            profile_identity_date_expire: "Ngày hết hạn CMND",
            profile_identity_image_back: "Ảnh mặt sau CMND",
            profile_identity_image_front: "Ảnh mặt trước CMND",
            profile_identity_number: "Số CMND",
            profile_last_name: "Họ",
            profile_nationality: "Quốc tịch",
            profile_passport_image_back: "Ảnh mặt sau hộ chiếu",
            profile_passport_image_front: "Ảnh mặt trước hộ chiếu",
            register_type: "Loại đăng ký",
            registration_date_v1: "Ngày đăng ký",
            registration_date_v2: "Ngày đăng ký",
            registration_number: "Số đăng ký",
            registration_number_v1: "Số đăng ký",
            registration_number_v2: "Số đăng ký",
            registration_type: "Loại",
            registration_type_v1: "Loại",
            registration_year_v1: "Năm đăng ký",
            registration_year_v2: "Năm đăng ký",
            request_change_description: "mô tả yêu cầu thay đổi",
            request_change_description2: "mô tả yêu cầu thay đổi",
            security_date: "Ngày bảo lãnh",
            security_number: "Số biên lai",
            security_office: "Văn phòng bảo lãnh",
            security_serial: "Số seri bảo lãnh",
            steer: "Vô lăng",
            to_date: "Đến ngày",
            type: "Loại",
            vehicle_type: "Loại",
            verify_amend_description: "mô tả",
            year: "Năm"
        }
    }
}